import { Component } from '@angular/core';

@Component({
  selector: 'app-chart-loader',
  templateUrl: './chart-loader.component.html',
  styleUrls: ['./chart-loader.component.scss']
})
export class ChartLoaderComponent {

}
